<template>
  <div class="btn">
    <div class="img">
      <img src="../../assets/images/brandCustom/btn_bg.png" alt="" />
      <div class="img-click animate img-click1" @click="handleUrl"></div>
      <!-- <div class="img-click animate img-click2" @click="handleUrl"></div> -->
      <div class="img-click animate img-click3" @click="handleUrl"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "interactive",
  components: {},
  data() {
    return {};
  },
  mounted: function() {},
  methods: {
    handleUrl() {
      window.open("https://fw.jd.com/main/detail/FW_GOODS-1503606");
    },
  },
};
</script>

<style scoped>
.btn {
  width: 1000px;
  margin: 0 auto;
}
.img {
  position: relative;
  width: 100%;
  height: 100%;
  /* background: url("../../assets/images/京东云短信V3.10迭代（互动营销引导页面）.png") no-repeat; */
}

.img img {
  width: 100%;
}
.img-click {
  cursor: pointer;
  /* background: red; */
  position: absolute;
  left: 39.7%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  opacity: 0;
}
.img-click1 {
  width: 21%;
  height: 140px;
  top: 5.28%;
  background: url("../../assets/images/brandCustom/btn.png") no-repeat;
  background-size: 100% auto;
}
/* .img-click2 {
  top: 49.9%;
  width: 21%;
  height: 140px;
  background: url("../../assets/images/brandCustom/btn.png") no-repeat;
  background-size: 100% auto;
} */
.img-click3 {
  width: 21%;
  height: 140px;
  /* bottom: 1.2%;
   */
  bottom: 7.5%;
  background: url("../../assets/images/brandCustom/btn.png") no-repeat;
  background-size: 100% auto;
}
.animate {
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-name: breathe;
  -webkit-animation-duration: 500ms;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-direction: alternate;
}
@-webkit-keyframes breathe {
  0% {
    opacity: 1;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
